import slugify from 'slugify'

export default function slugifyText(text: string) {
    /** Remove quotes from text */
    const sanitizedText = text.replace(/&quot;/g, '')
    return slugify(sanitizedText, { lower: true, remove: /[&*+~.()'"!:@?/]/g })
}
